import React from "react";
import {Col, Collapse, Row} from "antd";
import "./article.related.scss";
import {CatalogRelatedArticle} from "../../../models/articles/catalog/search";
import {ArticleCard} from "./article-card/article-card";

interface ArticleRelatedProps {
    data: CatalogRelatedArticle[];
    header: string;
}

export const ArticleRelated: React.FC<ArticleRelatedProps> = ({data, header}) => {

    return (
        <Row>
            <Collapse
                className="article_comparison-collapse article_collapse"
                expandIconPosition="right"
                bordered={false}
                defaultActiveKey={0}
            >
                <Collapse.Panel key={0} header={header}>
                    <Row gutter={[20, 20]}>
                        {data.map(item => (
                            <Col>
                                <ArticleCard article={item} imageSize={200} />
                            </Col>
                        ))}
                    </Row>
                </Collapse.Panel>
            </Collapse>
        </Row>
    );
};
